import { useEffect, useMemo, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Style from "./style.module.css";
import { Trash2, Search } from "lucide-react";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  SelectSearch,
} from "../../../../../../component/form/form-layout";
import XCloseIcon from "../../../../../../component/icons/x-close";
import LeftSidePopupLayout from "../../../../../../component/popup/modal-layout";
import { useApiCall } from "../../../../../../component/custom-hooks/api-call";
import InnerLoader from "../../../../../../component/ui/loader/inner-loader";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../../../../component/table/table-layout";

const AddAssigned = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  assignedData = {},
  brandsOpt = [],
}) => {
  const apiCall = useApiCall();

  const [updateLoading, setUpdateLoading] = useState(false);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [search, setSearch] = useState("");

  // DEFAULT DATA SET...
  useEffect(() => {
    if (assignedData?.id) {
      getassignedData(assignedData?.id);
    }
  }, []);

  const getassignedData = async (id) => {
    setUpdateLoading(true);
    try {
      const res = await apiCall({
        method: "get",
        url: `sales/get-assigned-sales-product-price-range/${id}`,
      });

      let newassignedData = res?.data;
      // formik.setFieldValue(
      //   "brands",
      //   Array.isArray(newassignedData?.teams)
      //     ? newassignedData?.teams.map((team) => team)
      //     : [],
      // );
      setAssignedUsers(newassignedData);
    } catch (error) {
    } finally {
      setUpdateLoading(false);
    }
  };

  const handleDelete = (id) => {
    setAssignedUsers((prev) =>
      prev.filter((br) => Number(br?.brand_id) !== Number(id)),
    );
  };

  const assignedBrandIds = assignedUsers.map((b) => Number(b?.brand_id));

  // helpers to map options

  const brandsOptions = brandsOpt
    ?.filter((br) => !assignedBrandIds.includes(br.id))
    ?.map((c) => ({
      value: c.id,
      label: c.value,
    }));

  // const validationSchema = yup.object({
  //   // brands: yup
  //   //   .array()
  //   //   .of(yup.string())
  //   //   .min(1, "This Field is Required")
  //   //   .required("This Field is Required"),
  // });

  const formik = useFormik({
    initialValues: {
      brands: "",
    },
    // validationSchema: validationSchema,
    onSubmit: async (values) => {
      const assignedBrandIds = assignedUsers.map((b) => b?.brand_id);
      const selectedBrandIds = values?.brands
        ? values?.brands?.map((id) => Number(id))
        : [];

      const allBrandIds = [
        ...new Set([...assignedBrandIds, ...selectedBrandIds]),
      ];
      let data = {
        sales_product_id: assignedData?.id,
        brand_ids: allBrandIds,
      };

      console.log("Form data", data);

      try {
        let apiRes = await apiCall({
          method: "post",
          url: `sales/products/assign-sales-product-price-range`,
          data: data,
        });
        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
        onClose();
      } catch (error) {
        console.log("Error", error);
        const res = error?.response?.data;

        if (res?.errors) {
          formik.setErrors(
            Object.fromEntries(
              Object.entries(res.errors).map(([key, value]) => [key, value[0]]),
            ),
          );
        }
        onError(
          error?.response.data?.respMsg ||
            error?.response.data?.responseMessage ||
            error?.response.data?.message ||
            "Some Thing Went Wrong",
        );
      }
    },
  });

  const filteredUsers = useMemo(() => {
    if (!search.trim()) return assignedUsers;

    return assignedUsers?.filter((u) =>
      u?.brand_name?.toLowerCase().includes(search.toLowerCase()),
    );
  }, [search, assignedUsers]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}
      >
        <div
          className={`${Style["modal_header"]} ${Style.addMeModal_head} !flex !justify-between !items-center`}
        >
          <div className="flex flex-col gap-1">
            <h4>Brand Assigned</h4>
            <p className="text-sm text-gray-700">
              Product: {assignedData?.name}
            </p>
          </div>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
          >
            <XCloseIcon />
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          {updateLoading ? (
            <div className="flex justify-center items-center !h-full w-full">
              <InnerLoader />
            </div>
          ) : (
            <FormArea>
              {/* Brands ID*/}
              <FeildWraper width="100%">
                <FormLabel>Brands</FormLabel>

                <SelectSearch
                  name="brands"
                  multiple
                  placeholder="- Select Brands -"
                  onChange={(val) => {
                    formik.setFieldValue("brands", val);
                  }}
                  value={formik.values.brands}
                  options={brandsOptions}
                  // onBlur={() => formik.setFieldTouched("brands", true, true)}
                  menuPosition="fixed"
                />

                {/* {formik.touched.brands && formik.errors.brands && (
                  <FeildError>{formik.errors.brands}</FeildError>
                )} */}
              </FeildWraper>

              {assignedUsers?.length > 0 ? (
                <div className="w-full p-[10px]">
                  <TableCard className="!h-full !max-h-[400px]">
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell header sticky>
                            <div className="flex justify-between items-center h-full">
                              <TableHeaderWrap>
                                <span className="">Assigned Brands</span>
                              </TableHeaderWrap>
                              {/* <div className="selectUser-search flex items-center gap-2  mb-2 border-gray-400 ">
                                <div className="icon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                  >
                                    <mask
                                      id="mask1"
                                      style={{ maskType: "alpha" }}
                                      maskUnits="userSpaceOnUse"
                                      x="0"
                                      y="0"
                                      width="18"
                                      height="18"
                                    >
                                      <rect
                                        width="18"
                                        height="18"
                                        fill="#D9D9D9"
                                      ></rect>
                                    </mask>
                                    <g mask="url(#mask1)">
                                      <path
                                        d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z"
                                        fill="#999999"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                <input
                                  type="text"
                                  placeholder="Search User..."
                                  className="customSearchInput border rounded px-2 py-1 w-full"
                                  value={search}
                                  onChange={(e) => setSearch(e.target.value)}
                                />
                              </div> */}

                              <div
                                className="selectUser-search flex items-center gap-2  px-3 py-2 bg-white border border-gray-300 rounded-lg shadow-sm transition
                              focus-within:border-blue-500 focus-within:ring-4 focus-within:ring-blue-100"
                              >
                                <Search className="h-4 w-4 text-gray-400 flex-shrink-0" />

                                <input
                                  type="text"
                                  placeholder="Search Brand…"
                                  className="customSearchInput w-full bg-transparent text-sm text-gray-800 placeholder-gray-400 focus:outline-none"
                                  value={search}
                                  onChange={(e) => setSearch(e.target.value)}
                                />
                              </div>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {filteredUsers
                          ?.filter((user) => user.status == 1)
                          ?.map((eachList, index) => {
                            return (
                              <>
                                <TableRow key={`${index}`}>
                                  <TableCell sticky>
                                    <div
                                      className={`${Style.tableActionArea} !gap-4`}
                                    >
                                      <div className="flex items-center gap-3">
                                        <div className="font-medium leading-5 ">
                                          {eachList?.brand_name}
                                        </div>
                                      </div>

                                      <div
                                        className={
                                          Style.tableActionAreaBtnGrpup
                                        }
                                      >
                                        <div
                                          className={
                                            "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                          }
                                          onClick={() =>
                                            handleDelete(eachList?.brand_id)
                                          }
                                        >
                                          <div
                                            className={Style.icon}
                                            style={{
                                              color: "red",
                                              cursor: "pointer",
                                            }}
                                          >
                                            <Trash2 className="h-4.5 w-4.5" />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </TableCell>
                                </TableRow>
                              </>
                            );
                          })}
                        {filteredUsers?.length == 0 && (
                          <div className="flex justify-center items-center h-full">
                            <span className="text-gray-400 py-2">
                              No Brands found
                            </span>
                          </div>
                        )}
                      </TableBody>
                    </Table>
                  </TableCard>
                </div>
              ) : null}
            </FormArea>
          )}
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel}`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            {assignedUsers?.length > 0 ? "Update" : "Add"} Assigned
          </button>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default AddAssigned;
